class KeepWatching {
  id: string;
  mark: number;
  constructor(id: string, mark: number) {
    this.id = id;
    this.mark = mark;
  }
}

export default KeepWatching;
